module.exports = __webpack_public_path__ + "static/media/IMG_2669.772fa7f1.JPG";